"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessagingPlaceholders = exports.getIsMessagingPlaceholdersRejected = exports.getIsMessagingPlaceholdersFulfilled = exports.getIsMessagingPlaceholdersPending = exports.getIsMessagingPlaceholdersIdle = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var getMessagingPlaceholdersState = function getMessagingPlaceholdersState(state) {
  return state.modules.messaging.placeholders;
};

var getMessagingPlaceholdersStatus = (0, _ramda.pipe)(getMessagingPlaceholdersState, (0, _ramda.prop)('status'));
var getIsMessagingPlaceholdersIdle = (0, _ramda.pipe)(getMessagingPlaceholdersStatus, (0, _ramda.equals)(_utils.StateStatus.Idle));
exports.getIsMessagingPlaceholdersIdle = getIsMessagingPlaceholdersIdle;
var getIsMessagingPlaceholdersPending = (0, _ramda.pipe)(getMessagingPlaceholdersStatus, (0, _ramda.equals)(_utils.StateStatus.Pending));
exports.getIsMessagingPlaceholdersPending = getIsMessagingPlaceholdersPending;
var getIsMessagingPlaceholdersFulfilled = (0, _ramda.pipe)(getMessagingPlaceholdersStatus, (0, _ramda.equals)(_utils.StateStatus.Fulfilled));
exports.getIsMessagingPlaceholdersFulfilled = getIsMessagingPlaceholdersFulfilled;
var getIsMessagingPlaceholdersRejected = (0, _ramda.pipe)(getMessagingPlaceholdersStatus, (0, _ramda.equals)(_utils.StateStatus.Rejected));
exports.getIsMessagingPlaceholdersRejected = getIsMessagingPlaceholdersRejected;
var getMessagingPlaceholders = (0, _ramda.pipe)(getMessagingPlaceholdersState, (0, _ramda.prop)('data'));
exports.getMessagingPlaceholders = getMessagingPlaceholders;